import { api } from '@/api';

class MerchantsService {
  async getMerchants() {
    return api.v1.merchants.get();
  }
}

export const merchantsService = new MerchantsService();
